import { authenticatedFetch } from '../../api/request';

export default async function updatePaymentMethodForUser(nonce: string) {
    return authenticatedFetch('/1.0/user/payment/setPrimaryPaymentMethod', {
        method: 'POST',
        body: JSON.stringify({ nonce })
    });
}
